import * as React from "react";
import { FetchWithAuth } from "digimaker-ui/util";
import {
  Form,
  Button,
  Breadcrumb,
  FormInstance,
  Select,
  Space,
  message,
} from "antd";
import "antd/dist/antd.css";
import { SendOutlined, CloseOutlined } from "@ant-design/icons";
import AntdFormItemFactory from "../lib/AntdFormItemFactory";
import DataSource, { DATE_SUBMIT_FORMAT } from "../lib/DataSource";
import Moment from "moment";
import { Link } from "react-router-dom";
import { util } from "../lib/Util";

const { Option } = Select;

export default class StudentEdit extends React.Component<
  {
    id: number;
    history: any;
  },
  {
    definition: any;
    fields: any;
    data: any;
    validation: any;
    agencyList: any;
    courseList: any;
  }
> {
  contentType = "student";
  formRef = React.createRef<FormInstance>();

  constructor(props) {
    super(props);
    this.state = {
      definition: null,
      fields: [],
      data: null,
      validation: "",
      agencyList: [],
      courseList: [],
    };
  }

  loadData() {
    DataSource.loadData(this.contentType, this.props.id).then((data) => {
      this.setState({ data: data });
    });
  }

  fillData(data: any) {
    this.formRef.current!.setFieldsValue({
      ...data,
      birthdate: Moment(data.birthdate),
      starting_date: Moment(data.starting_date),
    });
  }

  componentWillMount() {
    let studentDef = DataSource.loadFields(this.contentType).then((state) =>
      this.setState({
        definition: state.definition,
        fields: state.fields,
      }),
    );

    let courseDef = DataSource.loadList("course", {
      sortby: "c.name asc",
    }).then((courseList) =>
      this.setState({
        courseList: courseList.list,
      }),
    );

    let agencyDef = DataSource.loadList("agency", {
      sortby: "c.name asc",
    }).then((agencyList) =>
      this.setState({
        agencyList: [{ id: 0, name: "None" }, ...agencyList.list],
      }),
    );

    Promise.all([studentDef, courseDef, agencyDef]).then(() => this.loadData());
  }

  componentDidUpdate() {
    if (this.state.data) {
      this.fillData(this.state.data);
    }
  }

  handleSubmit(values) {
    if (values.birthdate) {
      values.birthdate = values.birthdate.format(DATE_SUBMIT_FORMAT);
    }

    if (values.starting_date) {
      values.starting_date = values.starting_date.format(DATE_SUBMIT_FORMAT);
    }

    let url = "content/update/" + this.contentType + "/" + this.props.id;
    FetchWithAuth(url, {
      method: "POST",
      body: JSON.stringify(values),
    }).then((data) => {
      this.setState({ validation: data });
      console.log(data);
      if (!data.error) {
        this.props.history.push("/student/view/" + this.props.id);
      } else {
        util.handleError(data.error);
      }
    });
  }

  render() {
    if (
      this.state.fields.length === 0 ||
      !this.state.data ||
      this.state.courseList.length === 0
    ) {
      return <div className="loading"></div>;
    }

    let fieldFactory = new AntdFormItemFactory();
    let fields = this.state.fields;
    let data = this.state.data;
    let intakes = util.intakes();
    let courseList = this.state.courseList;
    let agencyList = this.state.agencyList;

    return (
      <div id={"edit-" + this.contentType}>
        <h2>Edit {data.content_type}</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/student/list">Student</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={"/student/view/" + this.props.id}>{this.props.id}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit</Breadcrumb.Item>
        </Breadcrumb>
        <Form
          className="icd-form"
          name={this.contentType + "-edit"}
          ref={this.formRef}
          onFinish={(values) => this.handleSubmit(values)}
        >
          {fieldFactory.getFormItem(fields.firstname, data)}
          {fieldFactory.getFormItem(fields.lastname, data)}
          {fieldFactory.getFormItem(fields.birthdate, data)}
          {fieldFactory.getFormItem(fields.student_no, data)}
          {fieldFactory.getFormItem(fields.sex, data)}
          {fieldFactory.getFormItem(fields.nationality, data)}
          {fieldFactory.getFormItem(fields.telephone, data)}
          {fieldFactory.getFormItem(fields.email, data)}
          {fieldFactory.getFormItem(fields.address1, data)}
          {fieldFactory.getFormItem(fields.address2, data)}
          {fieldFactory.getFormItem(fields.address3, data)}
          {fieldFactory.getFormItem(fields.address4, data)}
          {fieldFactory.getFormItem(fields.intake, data)}
          {fieldFactory.getFormItem(fields.stage, data)}

          {fieldFactory.getFormItem(
            fields.status,
            null,
            "select",
            util.statusList.map((status) => {
              return { value: status, name: status };
            }),
          )}

          {fieldFactory.getFormItem(
            fields.course,
            data,
            "select",
            courseList.map((course) => {
              return { value: course.id, name: course.name };
            }),
          )}
          {fieldFactory.getFormItem(
            fields.agency,
            data,
            "select",
            agencyList.map((agency) => {
              return { value: agency.id, name: agency.name };
            }),
          )}
          {fieldFactory.getFormItem(fields.note, data)}

          {fieldFactory.getFormItem(fields.entry_year, data)}

          <Space>
            <Button type="primary" icon={<SendOutlined />} htmlType="submit">
              Submit
            </Button>
            <Link to="/student/list">Cancel</Link>
          </Space>
        </Form>
      </div>
    );
  }
}
